import * as Yup from "yup";

const CompanyOrganizationLevelSchema = Yup.object().shape({
  organization: Yup.array()
    .of(
      Yup.object().shape({
        organizationLevelName: Yup.string().required("Required"), // these constraints take precedence
        organizationLevelNameEn: Yup.string().required("Required"), // these constraints take precedence
      })
    )
    .required("Must have friends"), // these constraints are shown if and only if inner constraints are satisfied
});

export default CompanyOrganizationLevelSchema;
